"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcodeLocationWrapper$ = exports.OutcodeLocationWrapper$outboundSchema = exports.OutcodeLocationWrapper$inboundSchema = void 0;
exports.outcodeLocationWrapperToJSON = outcodeLocationWrapperToJSON;
exports.outcodeLocationWrapperFromJSON = outcodeLocationWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const outcodelocationattributes_js_1 = require("./outcodelocationattributes.js");
/** @internal */
exports.OutcodeLocationWrapper$inboundSchema = z.object({
    attributes: outcodelocationattributes_js_1.OutcodeLocationAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("outcode").default("outcode").optional(),
});
/** @internal */
exports.OutcodeLocationWrapper$outboundSchema = z.object({
    attributes: outcodelocationattributes_js_1.OutcodeLocationAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("outcode").default("outcode"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutcodeLocationWrapper$;
(function (OutcodeLocationWrapper$) {
    /** @deprecated use `OutcodeLocationWrapper$inboundSchema` instead. */
    OutcodeLocationWrapper$.inboundSchema = exports.OutcodeLocationWrapper$inboundSchema;
    /** @deprecated use `OutcodeLocationWrapper$outboundSchema` instead. */
    OutcodeLocationWrapper$.outboundSchema = exports.OutcodeLocationWrapper$outboundSchema;
})(OutcodeLocationWrapper$ || (exports.OutcodeLocationWrapper$ = OutcodeLocationWrapper$ = {}));
function outcodeLocationWrapperToJSON(outcodeLocationWrapper) {
    return JSON.stringify(exports.OutcodeLocationWrapper$outboundSchema.parse(outcodeLocationWrapper));
}
function outcodeLocationWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutcodeLocationWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutcodeLocationWrapper' from JSON`);
}
//# sourceMappingURL=outcodelocationwrapper.js.map